import type { ThemeColors, ThemeShades } from '/#/common/theme'

/**
 * @name shades
 * @description Shades of colors from 50 to 900
 * @type {number[]}
 */
export const shades: ThemeShades[] = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900]

/**
 * @name themeColors
 * @description Theme colors that are used in the application
 * @type {ThemeColors[]}
 */
export const themeColors: ThemeColors[] = [
  'primary',
  'secondary',
  'slate',
  'success',
  'warning',
  'danger',
  'info',
  'white',
  'black',
  'tertiary',
]

/**
 * @name colorPalette
 * @description Color palette for the application
 */
export const colorPalette = {
  white: { DEFAULT: '#ffffff' },
  black: { DEFAULT: '#000000' },
  current: { DEFAULT: 'currentColor' },
  transparent: { DEFAULT: 'transparent' },
  inherit: { DEFAULT: 'inherit' },
  red: {
    DEFAULT: '#ff5247',
    50: '#ffeeed',
    100: '#ffc9c6',
    200: '#ffafaa',
    300: '#ff8b84',
    400: '#ff756c',
    500: '#ff5247',
    600: '#e84b41',
    700: '#b53a32',
    800: '#8c2d27',
    900: '#6b221e',
  },
  dark_blue: {
    DEFAULT: '#52608f',
    50: '#eeeff4',
    100: '#c9cedc',
    200: '#afb6cb',
    300: '#8b94b4',
    400: '#7580a5',
    500: '#52608f',
    600: '#4b5782',
    700: '#3a4466',
    800: '#2d354f',
    900: '#22283c',
  },
  blue: {
    DEFAULT: '#3b82f6',
    50: '#eff6ff',
    100: '#dbeafe',
    200: '#bfdbfe',
    300: '#93c5fd',
    400: '#60a5fa',
    500: '#3b82f6',
    600: '#2563eb',
    700: '#1d4ed8',
    800: '#1e40af',
    900: '#1e3a8a',
  },
  yellow: {
    DEFAULT: '#eab308',
    50: '#fefce8',
    100: '#fef9c3',
    200: '#fef08a',
    300: '#fde047',
    400: '#facc15',
    500: '#eab308',
    600: '#ca8a04',
    700: '#a16207',
    800: '#854d0e',
    900: '#713f12',
  },
  green: {
    DEFAULT: '#22c55e',
    50: '#f0fdf4',
    100: '#dcfce7',
    200: '#bbf7d0',
    300: '#86efac',
    400: '#4ade80',
    500: '#22c55e',
    600: '#16a34a',
    700: '#15803d',
    800: '#166534',
    900: '#14532d',
  },
  rose: {
    DEFAULT: '#f43f5e',
    50: '#fff1f2',
    100: '#ffe4e6',
    200: '#fecdd3',
    300: '#fda4af',
    400: '#fb7185',
    500: '#f43f5e',
    600: '#e11d48',
    700: '#be123c',
    800: '#9f1239',
    900: '#881337',
  },
  slate: {
    DEFAULT: '#64748b',
    50: '#f8fafc',
    100: '#f1f5f9',
    200: '#e2e8f0',
    300: '#cbd5e1',
    400: '#94a3b8',
    500: '#64748b',
    600: '#475569',
    700: '#334155',
    800: '#1e293b',
    900: '#0f172a',
    950: '#020617',
  },
  indigo: {
    DEFAULT: '#6366f1',
    50: '#eef2ff',
    100: '#e0e7ff',
    200: '#c7d2fe',
    300: '#a5b4fc',
    400: '#818cf8',
    500: '#6366f1',
    600: '#4f46e5',
    700: '#4338ca',
    800: '#3730a3',
    900: '#312e81',
  },
  pink: {
    DEFAULT: '#ec4899',
    50: '#fdf2f8',
    100: '#fce7f3',
    200: '#fbcfe8',
    300: '#f9a8d4',
    400: '#f472b6',
    500: '#ec4899',
    600: '#db2777',
    700: '#be185d',
    800: '#9d174d',
    900: '#831843',
  },
  purple: {
    DEFAULT: '#a855f7',
    50: '#faf5ff',
    100: '#f3e8ff',
    200: '#e9d5ff',
    300: '#d8b4fe',
    400: '#c084fc',
    500: '#a855f7',
    600: '#9333ea',
    700: '#7e22ce',
    800: '#6b21a8',
    900: '#581c87',
    950: '#3b0764',
  },
}
